import { createLegacyBindingContext } from "../legacy/binding-context";

export const RUNTIME_INSTALLER_STATE_SYMBOL = Symbol.for("@visactor/vrender-core/runtime-installer-state");

function createRuntimeInstallerState() {
    return {
        runtimeInstallerContext: createLegacyBindingContext(),
        preloaded: !1,
        runtimeEntryKeys: new WeakMap,
        runtimeDrawContributions: new WeakMap,
        loadedRuntimeContributionModules: new WeakMap
    };
}

export function getRuntimeInstallerState() {
    const scope = globalThis;
    return scope[RUNTIME_INSTALLER_STATE_SYMBOL] || (scope[RUNTIME_INSTALLER_STATE_SYMBOL] = createRuntimeInstallerState()), 
    scope[RUNTIME_INSTALLER_STATE_SYMBOL];
}
//# sourceMappingURL=runtime-installer-state.js.map
